<template>
  <el-card shadow="never" class="aui-card--fill">
    <router-link to="/erp-store-log-manager" style="font-size: 18px;color: blue;">该功能已下线,请使用"库存管理-库存记录",点击跳转</router-link>
  </el-card>
</template>

<script>
import ChangeCount from '@/views/modules/StoreManager/common/ChangeCount.vue'
// import ReceiptCheckDialog from '@/views/modules/StoreManager/receipt/check-dialog'
import ImgViewer from '@/components/ImgViewer'
import ImageUploadDialog from '@/components/ImageUploadDialog'

export default {
  components: { ImgViewer, ImageUploadDialog,  ChangeCount },
  props: {
    productType: '',
  },
  data () {
    return {
      tableConfig: {
        queryUrl: '',
        deleteURL: '/store',
        autoLoad: false,
        otherHeight: 55
      },
      queryForm: {
        productCode: undefined,
        productType: '',
        productName: '',
        orderCode: '',
        storeName: '',
        storeType: '',
        senderName: '',
        isBack: '',
        hasReceipt: '',
        beginDate: '',
        endDate: '',
        creatorName: '',
        color: '',
        size: '',
        reason: '',
        attr1: '',
        attr2: '',
        businessMan:'',
        receiptCode:''
      }
    }
  },
  watch: {
    productType: {
      handler: function (newVal) {
        this.queryForm.productType = newVal
        this.$nextTick(() => {
          if (this.$refs.table) {
            this.$refs.table.reload()
          }
        })
      },
      immediate: true
    }
  },
  computed: {},
  methods: {
    downCheckFile () {
      this.$confirm(`核价单导出后相关记录将会锁定,是否继续?`).then(() => {
        this.$export(`/erp/store/log/export/check`, this.queryForm)
      })
    },
    showTransferDialog () {
      let rows = this.$refs.table.dataListSelections
      if (rows.length === 0) {
        return this.$message.error('请选择要调仓的批次')
      }
      const data = this.$clone(rows)
      let outStorageId = ''
      let validRes = true
      data.forEach((item) => {
        item.count = ''
        if (outStorageId == '') {
          outStorageId = item.storageId
        }
        if (outStorageId !== item.storageId) {
          validRes = false
        }
        item.product={
          id:item.productId,
          name:item.productName,
          nameZh:item.nameZh,
          code:item.productCode,
          skuCode:item.skuCode,
          color:item.color,
          size:item.size,
          attr1:item.attr1,
          attr2:item.attr2
        }
      })
      if (!validRes) {
        return this.$message.error('调出仓库不一致,请重新选择')
      }
      this.$refs.TransferDialog.dataForm.checkOutStorageId = outStorageId
      this.$refs.TransferDialog.dataForm.detailList = data
      this.$refs.TransferDialog.init()
    },
    companyNameFormatter (row, column, cellValue, index) {
      if (!cellValue) {
        return ''
      }
      return cellValue.replace('有限公司', '')
    },
    doExport () {
      this.$export('/erp/store/log/export', this.queryForm)
    },
    showReceiptCheckDialog () {
      let rows = this.$refs.table.dataListSelections
      let checkInRow = rows.filter(r => r.type == 1)
      if (!checkInRow || checkInRow.length == 0) {
        return this.$message.error('请选择收货记录')
      }
      this.$refs.ReceiptCheckDialog.init(checkInRow)
    },
    checkReceipt (row) {
      this.$confirm(`是否确认该价格,如驳回该价格可重新开票上传`, '操作提示', {
        confirmButtonText: '确认',
        cancelButtonText: '驳回',
        type: 'warning'
      }).then(() => {
        this.doCheckReceipt(row.id, 30)
      }).catch(() => {
        this.doCheckReceipt(row.id, 10)
      })
    },
    async doCheckReceipt (id, status) {
      const { data: res } = await this.$http.post(`/store/receipt/check`, { status: status, id: id })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.$message.success('操作成功')
      this.$refs.table.getDataList()
    },
    //上传图片凭证
    uploadImg () {
      let rows = this.$refs.table.dataListSelections
      if (rows.length === 0) {
        return this.$message.error('请选择出入库记录')
      }
      this.$refs.ImageUploadDialog.init()
    },
    //批量更新出入库记录图片
    uploadImgCompleted (imgs) {
      if (!imgs) {
        return this.$message.error('请上传图片')
      }
      let imgObj = JSON.parse(imgs)
      let rows = this.$refs.table.dataListSelections
      let ids = rows.map(item => item.id).join(',')
      this.$http.post(`/store/update/imgs`, { ids: ids, imgs: imgObj.join(',') }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success('保存成功')
        this.$refs.table.getDataList()
      })
    },
    cellStyleHandler ({ row, rowIndex, column }) {
      if (column.property === 'price') {
        if (row.status == 15) {
          return {
            backgroundColor: '#F56C6C',
            color: '#FFF'
          }
        }
      }
    },
  },
}
</script>

<style scoped></style>
